export const MinutesPassed = (date: string | Date): number => {
    const date1 = new Date();
    const date2 = new Date(date);
    const diffTime = date2.getTime() - date1.getTime();
    return diffTime / (1000 * 60);
}

export const GetDateString = (date?: string | Date): string => {
    let d: Date;
    d = date ? new Date(date) : new Date();

    let month: string = '' + (d.getMonth() + 1),
        day: string = '' + d.getDate(),
        year: number = d.getFullYear(),
        hours: number = d.getHours(),
        mins: number = d.getMinutes();
    
    if (month >= '1' && month <= '9')
        month = '0' + month.toString();
    if (day >= '0' && day <= '9')
        day = '0' + day.toString();
    if (hours >= 0 && hours <= 9)
        hours = Number('0' + hours.toString());
    if (mins >= 0 && mins <= 9)
        mins = Number('0' + mins.toString());

    return [year, month, day].join('-') + 'T' + [hours, mins].join(':');
}